<template>
  <!-- 展会报道详情页面 -->
  <div class="page-container">
    <!-- 展会报道卡片 -->
    <div class="page-card">
      <!-- 报道头部 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="2">
            <span style="line-height: 40px; font-weight: bold">展会报道</span>
          </el-col>
          <el-col :span="22" style="text-align: right">
            <el-button type="primary" size="small" @click="updateInfo">修改</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 报道内容展示 -->
      <div v-if="infoShow" class="page-card__body">
        <div style="margin: 20px 0">
          <el-image
            src="https://axhub.im/pro/f170dd528588df3c/images/%E5%B1%95%E4%BC%9A%E6%8A%A5%E9%81%93-%E8%AF%A6%E6%83%85/u4284.jpg"></el-image>
        </div>
        <div style="padding: 20px 0; font-weight: bold; font-size: 18px; line-height: 30px">
          紧固件高端研讨会
        </div>
        <div style="text-align: left; line-height: 28px; font-size: 14px">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.
          Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar
          sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
          Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin
          sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
          euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.
          Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient
          nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci,
          sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit.

          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.
          Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar
          sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
          Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin
          sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
          euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.
          Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient
          nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci,
          sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </div>
      </div>

      <!-- 报道编辑表单 -->
      <div v-else class="page-card__body">
        <div style="margin: 20px 0">
          <el-image
            src="https://axhub.im/pro/f170dd528588df3c/images/%E5%B1%95%E4%BC%9A%E6%8A%A5%E9%81%93-%E8%AF%A6%E6%83%85/u4284.jpg"></el-image>
        </div>
        <div>
          <el-form label-width="100px">
            <el-form-item style="text-align: left">
              <el-upload
                class="upload-demo"
                action=""
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="报道标题">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="报道内容">
              <vue-editor v-model="form.content"></vue-editor>
            </el-form-item>
            <el-form-item>
              <el-button type="primary">确认修改</el-button>
              <el-button>保存修改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {VueEditor} from "vue2-editor";

  export default {
    name: "eventMangeDetail",
    data() {
      return {
        infoShow: true,
        form: {
          content: '',
          title: '',
        }
      }
    },

    methods: {
      // 切换报道展示/编辑状态
      updateInfo() {
        this.infoShow = this.infoShow === false ? true : false
      }
    },
    components: {
      VueEditor
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/eventMangeDetail.vue